import { render, staticRenderFns } from "./OperateRegion.vue?vue&type=template&id=5b661718&scoped=true&"
import script from "./OperateRegion.vue?vue&type=script&lang=js&"
export * from "./OperateRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b661718",
  null
  
)

export default component.exports